import { Upload } from "antd";
// import ImgCrop from "antd-img-crop";
import { useContext, useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { addProfileImage } from "../../Redux/Actions/CardAction";
// import { CardContext } from "../../store/CardContext";
const App = () => {
  // const dispatch = useDispatch();

  const [fileList, setFileList] = useState([])
  // const [userData, setUserData] = useContext(CardContext)
  

  // useEffect(() => {
  //   setFileList(
  //     userData.profileImage
  //     ? [
  //         {
  //           uid: "-1",
  //           name: "image.png",
  //           status:  userData.profileImage ? "done" : "",
  //           url:  userData.profileImage,
  //         },
  //       ]
  //     : []
  //   )
  // }, [userData])

  // const [fileList, setFileList] = useState(
  //   userData.profileImage
  //     ? [
  //         {
  //           uid: "-1",
  //           name: "image.png",
  //           status:  userData.profileImage ? "done" : "",
  //           url:  userData.profileImage,
  //         },
  //       ]
  //     : []
  // );

  const onChange = ({ fileList: newFileList }) => {
    if (newFileList[0]?.status) { newFileList[0].status = "done"; }
    setFileList(newFileList);

    // dispatch(addProfileImage(fileList));
  };
  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };
  return (
    <>
      {/* <ImgCrop rotationSlider aspectSlider showReset> */}
        <Upload
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          listType="picture-card"
          fileList={fileList}
          onChange={onChange}
          onPreview={onPreview}
        >
          {fileList.length < 1 && "+ Upload"}
        </Upload>
      {/* </ImgCrop> */}
    </>
  );
};
export default App;
